import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { InsuranceItem } from '../../../../../../models/insurance-item.model';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { SortDirective } from '../../../../../../directives/sort.directive';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { CurrencyPipe, DecimalPipe, NgForOf, NgIf } from '@angular/common';
import { BaryButtonComponent } from '../../../../components';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { AlertService } from '../../../../../../services/alert.service';
import { InsuranceItemService } from '../../../../../../services/insurance-item.service';

@Component({
  selector: 'jhi-insurance-items-list',
  templateUrl: 'insurance-items-list.component.html',
  standalone: true,
  imports: [MDBBootstrapModulesPro, SortDirective, TranslateDirective, NgForOf, CurrencyPipe, DecimalPipe, BaryButtonComponent, TranslateModule, NgIf],
})
export class InsuranceItemsListComponent {
  private readonly modalService = inject(BaryModalService);
  private readonly translateService = inject(TranslateService);
  private readonly alertService = inject(AlertService);
  private readonly baryModalService = inject(BaryModalService);
  private readonly insuranceItemService = inject(InsuranceItemService);

  @Input() insuranceItems: InsuranceItem[] = [];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  public trackId(index: number, item: InsuranceItem): number {
    return item.id!;
  }

  public transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  public delete(insuranceItem: InsuranceItem): void {
    const message = this.translateService.instant('INSURANCE_ITEM_LIST.ACTION.REMOVE.MESSAGE', { itemsNature: insuranceItem.itemsNature });
    this.baryModalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.insuranceItemService.delete(insuranceItem.id!).subscribe(
            () => {
              const successMessage = this.translateService.instant('ALERT.SUCCESS.DATA_DELETED');
              this.alertService.addAlert({ message: successMessage, type: 'success' });
              this.transition();
            },
            e => {
              console.error(e);
              const successMessage = this.translateService.instant('ERROR.GENERIC');
              this.alertService.addAlert({ message: successMessage, type: 'danger' });
            }
          );
        }
      });
  }

  public edit(insuranceItem?: InsuranceItem): void {
    this.modalService
      .openAddOrUpdateInsuranceItem(insuranceItem)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.insuranceItemService.update(action.value).subscribe(() => {
            const successMessage = this.translateService.instant('MODAL_ADD_OR_UPDATE_INSURANCE_ITEM.TITLE.UPDATE', { param: action.value.itemsNature });
            this.alertService.addAlert({ message: successMessage, type: 'success' });
            this.transition();
          });
        }
      });
  }

  public isHidden(): boolean {
    return (this.insuranceItems && this.insuranceItems.length > 0) ?? false;
  }
}
